import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, resultCount }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const cityOptions = [
    { value: 'closest', label: 'الأقرب لموقعي' },
    { value: 'all', label: 'جميع المدن' },
    { value: 'riyadh', label: 'الرياض' },
    { value: 'jeddah', label: 'جدة' },
    { value: 'dammam', label: 'الدمام' },
    { value: 'mecca', label: 'مكة المكرمة' },
    { value: 'medina', label: 'المدينة المنورة' },
    { value: 'khobar', label: 'الخبر' },
    { value: 'taif', label: 'الطائف' },
    { value: 'tabuk', label: 'تبوك' },
    { value: 'abha', label: 'أبها' },
    { value: 'najran', label: 'نجران' }
  ];

  const photographyTypeOptions = [
    { value: 'all', label: 'جميع الأنواع' },
    // Hidden options: wedding, portrait, event, commercial, fashion, sports
    { value: 'product', label: 'تصوير المنتجات' },
    { value: 'real-estate', label: 'التصوير العقاري' },
    { value: 'food', label: 'تصوير الطعام' },
  ];

  const experienceLevelOptions = [
    { value: 'all', label: 'جميع المستويات' },
    { value: 'certified', label: 'معتمد' },
    { value: 'distinguished', label: 'مميز' },
    { value: 'elite', label: 'نخبة' }
  ];

  const handleReset = () => {
    onFilterChange({
      city: 'closest',
      photographyType: 'all',
      experienceLevel: 'all',
      minPrice: 0,
      maxPrice: 10000,
      sortBy: 'rating'
    });
  };

  return (
    <div className="bg-card rounded-xl shadow-warm p-4 md:p-6 lg:p-8 mb-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Icon name="SlidersHorizontal" size={24} className="text-primary" />
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">تصفية النتائج</h2>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-muted-foreground">
            {resultCount} مصور
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
            iconPosition="right"
            className="lg:hidden"
          >
            {isExpanded ? 'إخفاء' : 'عرض'}
          </Button>
        </div>
      </div>
      <div className={`space-y-4 md:space-y-6 ${isExpanded ? 'block' : 'hidden lg:block'}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Select
            label="المدينة"
            options={cityOptions}
            value={filters?.city}
            onChange={(value) => onFilterChange({ city: value })}
            searchable
          />

          <Select
            label="نوع التصوير"
            options={photographyTypeOptions}
            value={filters?.photographyType}
            onChange={(value) => onFilterChange({ photographyType: value })}
            searchable
          />

          <Select
            label="مستوى الخبرة"
            options={experienceLevelOptions}
            value={filters?.experienceLevel}
            onChange={(value) => onFilterChange({ experienceLevel: value })}
          />

          <Select
            label="ترتيب حسب"
            options={[
              { value: 'rating', label: 'الأعلى تقييماً' },
              { value: 'price-low', label: 'السعر: من الأقل للأعلى' },
              { value: 'price-high', label: 'السعر: من الأعلى للأقل' },
              { value: 'experience', label: 'الأكثر خبرة' }
            ]}
            value={filters?.sortBy}
            onChange={(value) => onFilterChange({ sortBy: value })}
          />
        </div>

        <div className="flex justify-end pt-4 border-t border-border">
          <Button
            variant="outline"
            onClick={handleReset}
            iconName="RotateCcw"
            iconPosition="right"
          >
            إعادة تعيين الفلاتر
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;